<template>
  <div class="col-xl-4 col-llg-6 col-lg-6 col-md-6 col-sm-12 prcustom product_col" :class='product_category' :id='product_code' :data-price='product_code'>
    <div class="card cardtableview cardclassicview" :class='zeroproductimg' :data-price='product_price'>
      <div class='cardtablediv' :class='backgroundtransparent'>
        <div class="flexcardbody">
          <div class="flexdesctitle">
            <svg v-b-tooltip.hover :title='product_description' aria-labelledby="svg-inline--fa-title-gwEmcLJQ3qlg" data-prefix="fas" data-icon="circle-info" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-circle-info fadetailsdesc tooltipwithdescription" aria-hidden="true" focusable="false" data-fa-i2svg=""><path fill="currentColor" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z"></path></svg>
            <h4 class="cardtittleprname mll-1">{{product_name}}</h4>
            <div class="badge_position">
              <!-- product based badges -->
              <b-badge pill class="small-badge ml-half" variant="warning" v-if="bestValueProducts.includes(product_code)">Best Value</b-badge>
              <b-badge pill class="small-badge ml-half" variant="info" v-if="mostPopularProducts.includes(product_code)">Most Popular</b-badge>
              <b-badge pill class="small-badge ml-half" variant="success" v-if="fullProtectionProducts.includes(product_code)">Full Protection</b-badge>
            </div>
            <div class="ml-auto">
              <img :src='product_img' alt="product logo" :data-imgprov='product_code' :class='product_code' class="logocard">
            </div>
          </div>
          <!-- basic desc -->
          <span class="shortdescsp" v-if="bestValueProducts.includes(product_code)">
            <div class="inline-bullets">
              • Holidaymakers on budget leisure trips
              &nbsp;&nbsp;• First-time travellers
              &nbsp;&nbsp;• Individuals needing visa-compliant essentials
            </div>
          </span>
          <!-- extented desc -->
          <span class="shortdescsp" v-if="mostPopularProducts.includes(product_code)">
            <div class="inline-bullets">
              • Families and couples on multi-city holidays
              &nbsp;&nbsp;• Travellers with mid-value equipment/luggage
              &nbsp;&nbsp;• Users looking for stronger protection
            </div>
          </span>
          <!-- luxury desc -->
          <span class="shortdescsp" v-if="fullProtectionProducts.includes(product_code)">
            <div class="inline-bullets">
              • Business travellers, executives, and long-stay trips
              &nbsp;&nbsp;• High-value trips (luxury cruises, global conferences)
              &nbsp;&nbsp;• Travellers with full protection expectations
            </div>
          </span>
          <span class="shortdescsp font-95" v-if="hasSecondaryCoverage">{{product_short_description}}</span>
        </div>
      </div>
      <div class="divprodctselectclassic cardtablediv" :class="backgroundtransparent">
        <div>
          <span class="titleprotablepriceclassic">{{ zeropricebtn ? 0 : totalPrice }} {{ product_currency }}</span>
          <div style="margin-top:5px;">
            <b-form-checkbox
              @change="storageOfferName()"
              :id="'offercp_'+product_code"
              :value="product_code"
              :data-price="product_price"
              name="products_arr[]"
            >
              Add to offer
            </b-form-checkbox>
          </div>
        </div>
        <input v-if="!zeropricebtn" @click='$emit("selectProductChange", $event.target)' :id="'button-tab'+product_code" :name="'tab'+product_code" type="button" value="Select" class="btn btn-success font-bold  buttonPrice" :data-product='product_code' :data-productname='product_name' :data-productprice='product_price' :data-productcategory='product_category'>
        <span v-else class="bg-danger text-white" style="padding:5px;border-radius:8px;">{{ zeropricebtnReason }}</span>
      </div>
      <div class=" showmorecoverages_bg showmorecovsclassic" :class="backgroundtransparent" @click="primarylist_show=!primarylist_show">
        <h6 class="titleprotable">Primary Coverages</h6>
        <font-awesome-icon icon="fa-solid fa-chevron-up" class="mtt-1 fascovs ml-1" size="lg" v-if="primarylist_show"/>
        <font-awesome-icon icon="fa-solid fa-chevron-down" class="mtt-1 fascovs ml-1" size="lg" v-else/>
      </div>
      <!-- v-if="primarylist_show" -->
      <div class="cardtablediv cardtabledivprimaryclassic" :class="backgroundtransparent" v-if="primarylist_show">
        <div v-for="p in primary" :key="p.index">
          <ul class="list-group list-group-horizontal list-froup-classic">
            <li class="list-group-item" :class="backgroundtransparent"><span class="listspanttt">Name</span>{{p.name_en}}</li>
            <li class="list-group-item" :class="backgroundtransparent"><span class="listspanttt">Excess</span>{{p.coverage_excess}}</li>
            <li class="list-group-item" :class="backgroundtransparent"><span class="listspanttt">Limit</span>{{p.coverage_limit}}</li>
          </ul>
        </div>
      </div>

      <div v-if="hasSecondaryCoverage" class="showmorecoverages_bg showmorecovsclassic" :class="backgroundtransparent" @click="secondarylist_show=!secondarylist_show">
        <div class="d-flex align-items-center">
          <h6 class="titleprotable">Secondary Coverages</h6>
          <font-awesome-icon icon="fa-solid fa-chevron-up" class="mtt-1 fascovs ml-1" size="lg" v-if="secondarylist_show"/>
          <font-awesome-icon icon="fa-solid fa-chevron-down" class="mtt-1 fascovs ml-1" size="lg" v-else/>
        </div>
      </div>
      <div class="cardtablediv cardtabledivsecondaryclassic" :class="backgroundtransparent" v-if="secondarylist_show">
        <div v-for="s in secondary" :key="s.index">
          <ul class="list-group list-group-horizontal list-froup-classic">
            <li class="list-group-item" :class="backgroundtransparent"><span class="listspanttt">Name</span>{{s.name_en}}</li>
            <li class="list-group-item" :class="backgroundtransparent"><span class="listspanttt">Excess</span>{{s.coverage_excess}}</li>
            <li class="list-group-item" :class="backgroundtransparent"><span class="listspanttt">Limit</span>{{s.coverage_limit}}</li>
          </ul>
        </div>
      </div>
      <div role="group" class="b-avatar-group pt-2 pb-2">
        <div style='display: flex;justify-content: center;align-items: center;width: 100%;' v-if='product_documents[product_code]'>
          <a style='margin:0 10px;border-radius:6px;' :href="product_documents[product_code].tob_link" target="_blank" class="btn btn-sm btn-outline-secondary tooltipwithdescription" v-b-tooltip.hover :title="product_documents[product_code].tob_title">TOB</a>
          <!-- Conditional for Sompo -->
          <div v-if="isSompoProduct" class="dropdown" style="margin: 0 10px;">
            <b-dropdown :id="'dropdown-' + product_code" text="PWO" variant="outline-secondary" size="sm">
                <b-dropdown-item target="_blank" :href="product_documents[product_code].pwo_link">Policy Wording (english)</b-dropdown-item>
                <b-dropdown-item target="_blank" :href="product_documents[product_code].pwo_link.replace('.pdf', '_EL.pdf')">Policy Wording (greek)</b-dropdown-item>
                <b-dropdown-item v-if="product_code=='product-longstay-302'" target="_blank" :href="product_documents[product_code].pwo_link_addition">Addition to the Policy Wording (english)</b-dropdown-item>
              </b-dropdown>
          </div>
          <!-- For other products, show regular PWO -->
          <a
            v-else
            style="margin: 0 10px; border-radius: 6px;"
            :href="product_documents[product_code].pwo_link"
            target="_blank"
            class="btn btn-sm btn-outline-secondary tooltipwithdescription"
            v-b-tooltip.hover
            :title="product_documents[product_code].pwo_title"
          >
            PWO
          </a>
          <a style='margin:0 10px;border-radius:6px;' :href="product_documents[product_code].ipid_link" target="_blank" class="btn btn-sm btn-outline-secondary tooltipwithdescription" v-b-tooltip.hover :title="product_documents[product_code].ipid_title">IPID
          </a>
        </div>
      </div>
      <!-- Start Trigger modal with options for Sompo Products -->
      <div v-if="isSompoProduct && optionVisible" class="showmorecoverages_bg showmorecovsclassic" :class="backgroundtransparent">
        <div class="d-flex align-items-center onadd_onselectsompo" @click="onProductSelect(product_code);">
          <h6 class="titleprotable">Add option</h6>
          <font-awesome-icon icon="fa-solid fa-chevron-right" class="ml-1" size="lg" />
        </div>
      </div>
      <!-- Modal with options for Sompo Products -->
      <b-modal
        :id="'optionModal_' + product_code"
        :ref="'optionModal_' + product_code"
        :title="'Select Optional Coverages for ' + product_name + ' Coverage'"
        size="lg"
        scrollable
        ok-only
      >
        <div class="row">
          <div class="col-12 mt-2" v-for="(category, index) in getCategoryDetails()" :key="category.key">
            <h5 class="text-secondary">Activity Category {{ index + 1 }}</h5>
            <p class="small text-secondary" v-html="category.header"></p>
            <p class="small" v-html="category.text"></p>
            <template>
              <b-table
                bordered
                small
                :items="productAddOns.filter(a => a.category === category.key)"
                :fields="fields"
              >
                <!-- Custom cell for 'name' field with checkbox -->
                <template #cell(name)="data">
                  <b-form-checkbox
                    :id="'option_' + product_code + '_' + category.key + '_' + data.item.id"
                    :value="data.item.id"
                    v-model="selectedOptions[category.key]"
                    @change="calculateTotalPrice(product_code)">
                    <span v-html="data.item.description"></span>
                  </b-form-checkbox>
                </template>
              </b-table>
            </template>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { product_documents, viewsProductsMixin } from '@/products';
  import {
    VBTooltip,
    BFormCheckbox,
    BBadge,
    BDropdown,
    BDropdownItem,
    BModal,
    BTable
  } from 'bootstrap-vue'
  export default {
    mixins: [viewsProductsMixin],
    components: {
      BFormCheckbox,
      BBadge,
      BDropdown,
      BDropdownItem,
      BModal,
      BTable
    },
    props:['product_price','product_currency','product_currency_symbol','product_category','product_code','product_description','product_name','product_short_description','primary','secondary','resCheckName','destCheckName','startDate','daysNum','agesArr'],
    directives: {
      'b-tooltip': VBTooltip,
    },
    data() {
      return {
        optionVisible: true,
        loadingAddons: false,
        productAddOns: [],
        selectedOptionsPerProduct: {},
        totalPrice: Number(this.product_price) || 0,
        fields: [
          {
            key: 'name',
            label: 'Optional Coverages',
          }
        ],
        selectedOptions: {
          category_1: [],
          category_2: [],
          category_3: [],
          category_4: []
        },
        primarylist_show: true,
        secondarylist_show: false,
        zeroproductimg: null,
        backgroundtransparent: null,
        zeropricebtn: false,
        zeropricebtnReason:'',
        product_documents,
        product_img: null,
        col_img: require('@/assets/images/quotation/globeinsure.png'),
        sompo_img: require('@/assets/images/quotation/sft.svg'),
        mon_img: require('@/assets/images/quotation/mondial.png'),
        kem_img: require('@/assets/images/quotation/kemter.png'),
        battle_img: require('@/assets/images/quotation/battleface.png'),
      }
    },
    created() {
      this.setImg();
    },
    mounted() {
      this.checkProducts("#");
      this.zeroProducts();
    }
  }
</script>